import { useAccount } from "@hooks/useAccount";
import { AccountPageLayout } from "./AccountPageLayout";
import { Loading } from "./Loading";
import { Error } from "./Error";
import styles from "./styles/Account.module.css";

export const Account = ({ session }) => {
  const { account, isLoading } = useAccount();

  if (account.error) {
    return <Error title="Account" errorMessage={account.error.message} />;
  }

  if (isLoading) {
    return <Loading title="Account" />;
  }

  //   TODO: @mudassirijaz786; for later use
  //   if (session.user.image) {
  //     // window.location.href = `https://checkout.kotn.com/account/login/multipass/${session.user.image}`;
  //     return null; // Optional: Return null to prevent rendering anything else
  //   }

  return (
    <AccountPageLayout title="Account">
      <p className={styles.welcome}>Welcome {account.customer.displayName}!</p>
    </AccountPageLayout>
  );
};
